import { render, staticRenderFns } from "./DiagramLegend.vue?vue&type=template&id=07c2492e&scoped=true&"
import script from "./DiagramLegend.vue?vue&type=script&lang=ts&"
export * from "./DiagramLegend.vue?vue&type=script&lang=ts&"
import style0 from "./DiagramLegend.vue?vue&type=style&index=0&id=07c2492e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c2492e",
  null
  
)

export default component.exports